import { PrefectureValue } from '@/constants/prefectures';
import { Option } from '@/types/options';
import { useTranslations } from 'next-intl';
import { JobCrewCategoryOptionFragment } from '../gen/graphql/JobsRoute.generated';
import { JobBenefitOptionFragment } from '../gen/graphql/JobsRoute.generated';
import { useI18nLabel } from '@/hooks/useI18nLabel';

export interface EmptyStateProps {
  prefecture: Option<PrefectureValue> | undefined;
  jobCategory: JobCrewCategoryOptionFragment | undefined;
  jobBenefit: JobBenefitOptionFragment | undefined;
}

export function EmptyState({ prefecture, jobCategory, jobBenefit }: EmptyStateProps) {
  const t = useTranslations('jobs.emptyState');
  const translate = useI18nLabel();

  const conditions = [
    prefecture ? prefecture.label : '',
    jobCategory ? translate(jobCategory) : '',
    jobBenefit ? translate(jobBenefit) : '',
  ]
    .filter(Boolean)
    .join(' + ');

  return (
    <div className="flex flex-col gap-y-4 py-8 px-4 bg-neutral-auxiliary-tinge rounded-medium text-center">
      <p className="text-medium font-bold">{t('title', { conditions })}</p>
      <p className="text-small">{t('body')}</p>
    </div>
  );
}
